import React from 'react'
import styled from '@emotion/styled'
import { object } from 'prop-types'

// Import Components
import { Breadcrumbs } from '../Breadcrumbs'
import { ContentSocialBlock } from '../ContentSocialBlock'

// Breadcrumb
const ContentToolBar = styled.div`
	background: ${({ theme }) => theme.colors.lightGrey};
	display: block;
	height: 50px;
	position: absolute;
	width: 100%;

	${({ theme }) => theme.MQ.M} {
		position: relative;
	}
`
const ToolBar = styled.div`
	color: ${({ theme }) => theme.colors.darkGrey};
	display: flex;
	height: inherit;
	margin: auto;

	${({ theme }) => theme.BMQ.MXL} {
		padding: 0 20px;
	}

	${({ theme }) => theme.MQ.M} {
		justify-content: space-between;
		align-items: center;
	}

	${({ theme }) => theme.MQ.XL} {
		${({ theme }) => theme.maxWidth.L};
	}
`
const BreadcrumbsWrapper = styled.div`
	${({ theme }) => theme.text.breadcrumb};
	font-size: 14px;
	margin: auto;
	padding: 0;
	position: absolute;
	text-align: center;
	text-shadow: 2px 2px 5px rgba(0, 0, 0, 0.5);
	top: -40px;
	width: 98%;

	${({ theme }) => theme.MQ.M} {
		display: inline-block;
		font-size: 16px;
		margin: auto 0;
		position: relative;
		text-shadow: none;
		top: 0;
		width: auto;
	}
`
const SocialBlockWrapper = styled.div`
	margin: auto;
	max-width: 250px;

	${({ theme }) => theme.MQ.M} {
		margin: 0;
		display: inline-block;
	}
`

HeroToolBar.propTypes = {
	breadcrumbs: object.isRequired,
}

export function HeroToolBar({ breadcrumbs }) {
	return (
		<ContentToolBar>
			<ToolBar>
				<BreadcrumbsWrapper>
					<Breadcrumbs breadcrumbs={breadcrumbs} />
				</BreadcrumbsWrapper>
				<SocialBlockWrapper>
					<ContentSocialBlock showShareThis={true} />
				</SocialBlockWrapper>
			</ToolBar>
		</ContentToolBar>
	)
}
